import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSnapchatIcon from './svgs/SnapchatIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var snapchatIcon = (props => useIcon(SvgSnapchatIcon, SvgSnapchatIcon, props));

export { snapchatIcon as default };
